import { useSelector } from 'react-redux';

import { getAuthenticatedUser } from '@/redux/selectors/auth/user';
import { useUserData } from '@/services/getUserData';

// The auth user carries no address, so this reads the full user; undefined while loading or logged out.
export const useProfileCountry = (): string | undefined => {
  const authenticatedUser = useSelector(getAuthenticatedUser);
  const { data } = useUserData(authenticatedUser?.id);

  return data?.data?.profile.address.country || undefined;
};
